import './DeviceLight.css'
import { Button } from '@mui/material'
// Components
import IonicPageWrapper from '../../components/IonicPageWrapper/IonicPageWrapper'
import LiveStreamModal from '../../components/LiveStreamModal/LiveStreamModal';
// ICONs & SVGs
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VideocamIcon from '@mui/icons-material/Videocam';
import lightIcon from '../../imgs/light_img.svg'

import IconButton from '@mui/material/IconButton';
import CircleIcon from '@mui/icons-material/Circle';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from "axios";
import { useSnackbar } from "notistack";
import { useHistory } from 'react-router';

function DeviceLight(props) {
    const { area_id } = useParams();
    const history = useHistory();
    const isloggedin = localStorage.getItem("loggedIn");

    const [streamModalOpen, setStreamModalOpen] = useState(false);
    const [selectedStreamDevice, setSelectedStreamDevice] = useState({ id: '001', name: '' });

    useEffect(() => {
        if(!isloggedin)
        {
            history.push('/login'); 
            window.location.reload(); 
        }
    }, []);

    const onBackClick = () => {
        history.push('/light', props.location.state);
    }
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [allDevices, setAllDevices] = useState([])

    useEffect(() => {
        setAllDevices([])
        fetchAllDevices();
    }, [area_id])

    const fetchAllDevices = async () => {
        setLoading(true);
        await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/users/getsubdatabyareaid`, { area_id })
            .then(res => {
                if (!res.data?.success) return enqueueSnackbar('No Device Found !!!', { variant: 'error' })
                if (res.data.success !== true) return enqueueSnackbar('No Device Found !!!', { variant: 'error' })
                setAllDevices(Array.isArray(res.data.data) ? res.data.data : []);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
                enqueueSnackbar('Error Fetching Devices !!!', { variant: 'error' })
            })
    }

    const pop = (cam_id) => {
        history.push(`/eachdevicelight/${cam_id}`);
    };

    const handleOpenStream = (devId, devName, e) => {
        if (e) e.stopPropagation();
        setSelectedStreamDevice({ id: devId, name: devName });
        setStreamModalOpen(true);
    };

    return (
        <IonicPageWrapper onBackClick={onBackClick} headerTitle='Lights' showLogout={true}>
            <div id="lightsControl">
                <div className="lights_cardCont">
                    {allDevices.map((device, index) => (
                        <DeviceLightCard
                            key={index}
                            no_device={device.cam_id}
                            area={device.cam_id}
                            data={device.data}
                            click={() => pop(device.cam_id)}
                            onStreamClick={(devId, name, e) => handleOpenStream(devId, name, e)}
                        />
                    ))}
                    {
                        (allDevices.length === 0)?
                        (
                            <h1>
                                No Devices Associated with this Area
                            </h1>
                        ):null
                    }
                </div>
            </div>

            <LiveStreamModal
                isOpen={streamModalOpen}
                onClose={() => setStreamModalOpen(false)}
                deviceId={selectedStreamDevice.id}
                deviceName={selectedStreamDevice.name}
            />
        </IonicPageWrapper>
    )
}

export default DeviceLight

const DeviceLightCard = ({ no_device, area, data, click, onStreamClick }) => {
    const subData = typeof data === 'string' ? JSON.parse(data) : (data || {});
    const isRed = subData.RED_LED === 'ON' || subData.LED_R === 'ON';
    const isGreen = subData.GREEN_LED === 'ON' || subData.LED_G === 'ON';
    const isYellow = subData.YELLOW_LED === 'ON' || subData.LED_Y === 'ON';
    const isWhite = subData.WHITE_LED === 'ON' || subData.LED_W === 'ON';

    return (
        <div className="lights_card" onClick={click}>
            <section className='lights_card_content'>
                <img src={lightIcon} alt="" />
                <p className='lights_card_device'>{no_device}</p>
                <p className='lights_card_area'>{area}</p>

                <Button
                    variant="contained"
                    size="small"
                    startIcon={<VideocamIcon />}
                    onClick={(e) => onStreamClick(no_device, area, e)}
                    sx={{
                        backgroundColor: '#1976d2 !important',
                        fontSize: '11px',
                        marginTop: '8px',
                        textTransform: 'none',
                        borderRadius: '12px',
                        fontWeight: 'bold'
                    }}
                >
                    Live Stream
                </Button>
            </section>

            <section className="lights_card_btnsCont">
                <IconButton aria-label="red" size="small">
                    <CircleIcon fontSize="medium" sx={{ color: !isRed ? '#ff12004f !important' : '#ff1200 !important' }} />
                </IconButton>
                <IconButton aria-label="green" size="small">
                    <CircleIcon fontSize="medium" sx={{ color: !isGreen ? '#00c8534f !important' : '#00c853 !important' }} />
                </IconButton>
                <IconButton aria-label="yellow" size="small">
                    <CircleIcon fontSize="medium" sx={{ color: !isYellow ? '#ffff004f !important' : '#ffff00 !important' }} />
                </IconButton>
                <IconButton aria-label="white" size="small">
                    <CircleIcon fontSize="medium" sx={{ color: !isWhite ? '#ffffff4f !important' : '#fff !important' }} />
                </IconButton>
            </section>
        </div>
    );
};